import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TJ2424Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TJ2424IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4H22V19H2V4Z"
          fill="#F7FCFF"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4V9H22V4H2Z"
          fill="#C51918"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 14V19H22V14H2Z"
          fill="#409100"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0127 9.39362L11.6432 9.65469L11.7736 9.2172L11.4149 8.94105L11.8649 8.93174L12.0127 8.5L12.1605 8.93174L12.6106 8.94105L12.2519 9.2172L12.3822 9.65469L12.0127 9.39362ZM10.4519 9.77671L10.0824 10.0378L10.2127 9.60029L9.854 9.32415L10.3041 9.31484L10.4519 8.8831L10.5996 9.31484L11.0497 9.32415L10.691 9.60029L10.8213 10.0378L10.4519 9.77671ZM8.86857 11.1867L9.23806 10.9256L9.60755 11.1867L9.4772 10.7492L9.83591 10.473L9.38586 10.4637L9.23806 10.032L9.09027 10.4637L8.64022 10.473L8.99893 10.7492L8.86857 11.1867ZM8.84785 12.4149L8.47836 12.6759L8.60871 12.2384L8.25 11.9623L8.70005 11.953L8.84785 11.5212L8.99564 11.953L9.44569 11.9623L9.08698 12.2384L9.21734 12.6759L8.84785 12.4149ZM14.7646 12.6759L15.1341 12.4149L15.5035 12.6759L15.3732 12.2384L15.7319 11.9623L15.2819 11.953L15.1341 11.5212L14.9863 11.953L14.5362 11.9623L14.8949 12.2384L14.7646 12.6759ZM14.6572 10.9256L14.2877 11.1867L14.418 10.7492L14.0593 10.473L14.5094 10.4637L14.6572 10.032L14.805 10.4637L15.255 10.473L14.8963 10.7492L15.0267 11.1867L14.6572 10.9256ZM13.0922 10.0378L13.4617 9.77671L13.8312 10.0378L13.7008 9.60029L14.0595 9.32415L13.6095 9.31484L13.4617 8.8831L13.3139 9.31484L12.8639 9.32415L13.2226 9.60029L13.0922 10.0378ZM9.91729 14.4717L9.80208 14.0614C10.4396 13.8889 11.1715 13.8031 11.998 13.8031C12.8244 13.8031 13.5563 13.8889 14.1939 14.0614L14.0787 14.4717C13.4811 14.31 12.7875 14.2287 11.998 14.2287C11.2085 14.2287 10.5149 14.31 9.91729 14.4717ZM10.7068 13.8138C10.4524 13.8571 10.2444 13.6112 10.2444 13.6112L10.4967 13.5069C10.4888 13.332 10.5943 13.2235 10.5943 13.2235C10.6796 13.2628 10.7961 13.4776 10.7961 13.4776H11.0249C11.0249 13.4776 10.9611 13.7706 10.7068 13.8138ZM13.713 13.6537C13.713 13.6537 13.505 13.8996 13.2507 13.8564C12.9963 13.8132 12.9326 13.5202 12.9326 13.5202H13.1613C13.1613 13.5202 13.2778 13.3054 13.3632 13.2661C13.3632 13.2661 13.4687 13.3745 13.4607 13.5495L13.713 13.6537ZM11.9661 13.7358C11.7082 13.7432 11.5365 13.4708 11.5365 13.4708L11.8009 13.4027C11.8173 13.2283 11.9369 13.1356 11.9369 13.1356C12.016 13.1864 12.1014 13.4153 12.1014 13.4153L12.3279 13.4472C12.3279 13.4472 12.224 13.7285 11.9661 13.7358Z"
          fill="#FFBB00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9743 12.5618C11.9743 12.5618 11.6812 13.2326 11.2195 13.2845C10.7579 13.3364 10.5234 12.903 10.5234 12.903C10.5234 12.903 10.4931 13.3537 9.94488 13.5274C9.39662 13.7012 9.10791 13.0071 9.10791 13.0071C9.10791 13.0071 9.39335 13.2624 9.83606 13.1511C10.2788 13.0399 10.4535 12.629 10.4535 12.629C10.4535 12.629 10.7812 13.0573 11.2195 12.8432C11.6579 12.629 11.9004 12.3672 11.9004 12.116V11.3649C11.9004 11.3649 11.7873 11.1701 11.5911 11.1701C11.3949 11.1701 11.3402 11.3082 11.3402 11.3082C11.3402 11.3082 11.2636 10.5268 11.9692 10.4785L11.9692 10.4766L11.9885 10.4773L12.0082 10.4766L12.0082 10.4785C12.7138 10.5268 12.6372 11.3082 12.6372 11.3082C12.6372 11.3082 12.5825 11.1701 12.3863 11.1701C12.1901 11.1701 12.077 11.3649 12.077 11.3649V12.1161C12.077 12.3672 12.3195 12.629 12.7579 12.8432C13.1962 13.0574 13.5239 12.629 13.5239 12.629C13.5239 12.629 13.6986 13.0399 14.1413 13.1511C14.584 13.2624 14.8695 13.0071 14.8695 13.0071C14.8695 13.0071 14.5808 13.7012 14.0325 13.5275C13.4842 13.3537 13.454 12.903 13.454 12.903C13.454 12.903 13.2195 13.3364 12.7579 13.2845C12.2962 13.2327 12.0031 12.5619 12.0031 12.5619L11.9887 11.6768L11.9743 12.5618ZM11.9675 10.6889C11.6419 10.6889 11.576 10.9645 11.576 10.9645C11.8626 10.9645 11.9675 11.0894 11.9675 11.0894C11.9675 11.0894 12.1797 10.9645 12.3933 10.9645C12.3933 10.9645 12.293 10.6889 11.9675 10.6889Z"
          fill="#FFBB00"
        />
      </svg>

      <defs>
        <clipPath id="clip0_2413_692">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TJ2424Icon;
